import AppData from '../../Model/MerchantAppData';
import BaseFirebaseRepository from './BaseFirebaseRepository';
import DeliveryDetail, { DeliveryDetail_fromJson } from '../../Model/DeliveryDetail';

const instances = {}
const defaultInstanceKey = Math.random()
export default class DeliveryDetailRepository extends BaseFirebaseRepository {
    /**
     * @param {*} app 
     * @return {DeliveryDetailRepository}
     */
    static getInstance(app) {
        if (app == null) {
            // By default, use instance created from main App
            app = AppData.context || defaultInstanceKey
        }
        if (app != null && instances[app] == null) {
            // Create a new instance
            instances[app] = new DeliveryDetailRepository(app)
        }
        return instances[app]
    }
    constructor(app) {
        super(app)
    }
    getRef = () => {
        return firebase.database().ref(firebase_path + '/delivery_details/')
            .orderByChild("id")
    }
    /**
     * Return the Firebase query for single item query
     */
    getSingleRef = () => {
        return firebase.database().ref(firebase_path + '/delivery_details/')
            .orderByChild("id")
    }
    getBaseObject = () => {
        return new DeliveryDetail()
    }
    /**
     * Data from Firebase is in snake_case, but throughout the
     * app we are accessing DeliveryDetail property via camelCase
     */
    preprocessItem = (rawFirebaseData) => {
        if (rawFirebaseData) {
            let castToFloat = ["base_charge", "delivery_charge", "processing_fee", "merchant_cover_fee"]
            castToFloat.forEach(key => [
                rawFirebaseData[key] = parseFloat(rawFirebaseData[key])
            ])
        }
        return DeliveryDetail_fromJson(rawFirebaseData)
    }
    loadAll = (callback, callbackKey, context) => {
        throw "Cannot load all, please use loadOne to load data"
    }
}